(() => {
  if (window.__UGBLaunchFixesLoaded) return;
  window.__UGBLaunchFixesLoaded = true;

  function builderFromTarget(target) {
    if (!(target instanceof Element)) return null;
    const form = target.closest('form');
    if (!(form instanceof HTMLFormElement)) return null;
    return form.querySelector('[data-ugb-gift-builder]');
  }

  function packagingGroup(builder) {
    return builder?.querySelector?.('[data-ugb-packaging-group]') || null;
  }

  function packagingSelected(builder) {
    const group = packagingGroup(builder);
    if (!group || group.dataset.required !== 'true') return true;
    return Boolean(group.querySelector('[data-ugb-addon-option]:checked'));
  }

  function packagingError(group) {
    let error = group.querySelector('[data-ugb-packaging-required-error]');
    if (!error) {
      error = document.createElement('p');
      error.className = 'ugb-packaging-required-error';
      error.dataset.ugbPackagingRequiredError = 'true';
      error.setAttribute('role', 'alert');
      error.textContent = 'Please select a gift packaging option.';
      const limitNote = group.querySelector('[data-ugb-packaging-limit-note]');
      if (limitNote) group.insertBefore(error, limitNote);
      else group.appendChild(error);
    }
    return error;
  }

  function revealPackaging(builder) {
    const group = packagingGroup(builder);
    if (!(group instanceof HTMLDetailsElement)) return false;

    group.open = true;
    group.classList.add('is-required-missing');
    group.setAttribute('aria-invalid', 'true');
    const error = packagingError(group);
    error.hidden = false;

    const globalError = builder.querySelector('[data-ugb-builder-error]');
    if (globalError) globalError.hidden = true;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        group.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
        const summary = group.querySelector('summary');
        if (summary instanceof HTMLElement) {
          window.setTimeout(() => summary.focus({ preventScroll: true }), 300);
        }
      });
    });
    return true;
  }

  function clearPackagingError(builder) {
    const group = packagingGroup(builder);
    if (!group) return;
    const selected = group.querySelector('[data-ugb-addon-option]:checked');
    if (!selected) return;
    group.classList.remove('is-required-missing');
    group.removeAttribute('aria-invalid');
    const error = group.querySelector('[data-ugb-packaging-required-error]');
    if (error) error.hidden = true;
  }

  function guardMissingPackaging(event, target) {
    const builder = builderFromTarget(target);
    if (!builder || packagingSelected(builder)) return false;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    revealPackaging(builder);
    return true;
  }

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const addButton = target.closest("[data-ugb-builder-button],button[name='add'],[data-testid='standalone-add-to-cart']");
    if (!addButton) return;
    guardMissingPackaging(event, addButton);
  }, true);

  document.addEventListener('submit', (event) => {
    if (!(event.target instanceof HTMLFormElement)) return;
    guardMissingPackaging(event, event.target);
  }, true);

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const group = target.closest('[data-ugb-packaging-group]');
    if (!group) return;
    const builder = group.closest('[data-ugb-gift-builder]');
    if (builder) clearPackagingError(builder);
  }, true);
})();
